import RadioActiveIcon from "../icons/RadioActiveIcon/RadioActiveIcon";
import theme from "../../style/theme";
import RadioInActiveIcon from "../icons/RadioInActiveIcon/RadioInActiveIcon";
import styled from "styled-components";

interface Props {
    isActive: boolean;
    onClick: () => void;
    optionName: string;
}

export const OptimizationOptionRadioButton: React.FC<Props> = (
    {
        isActive,
        onClick,
        optionName,
    }
) => {
    return (
        <Container onClick={onClick}>
            <LeftContent>
                {isActive ? (
                    <RadioActiveIcon fill={theme.palette.primitives.yellow400} />
                ) : (
                    <RadioInActiveIcon fill={theme.palette.primitives.gray200} />
                )}
            </LeftContent>
            <RightContent isActive={isActive}>{optionName}</RightContent>
        </Container>
    );
};

const Container = styled.div`
  width: fit-content;
  height: fit-content;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-direction: row;
  background: #ffffff;
  cursor: pointer;
`;

const LeftContent = styled.div`
  width: 30px;
  height: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 12px 0 0;
  box-sizing: border-box;
`;

interface RightContentProps {
    isActive: boolean;
}

const RightContent = styled.div<RightContentProps>`
  width: fit-content;
  height: 19px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) =>
    props.isActive
        ? theme.palette.primitives.gray900
        : theme.palette.primitives.gray400};

  &:hover {
    color: ${theme.palette.primitives.gray900};
  }
`;
